module.exports = __webpack_public_path__ + "static/media/BM_Jobs.dcdada83.svg";